var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.dataLoading)?_c('el-skeleton',{attrs:{"rows":13,"animated":""}}):_c('div',{attrs:{"id":"pie-chart"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }